import { Button } from '@jotta/ui/Button'
import { Input } from '@jotta/ui/Input'
import { Label } from '@jotta/ui/Label'
import { Trans, t } from '@lingui/macro'
import type { ChangeEventHandler, FC } from 'react'
import { useState } from 'react'
import { Paragraph } from '../../Typography/Text/Text'
import type { RadixDialogProps } from '../RadixDialog/RadixDialog'
import { RadixDialog } from '../RadixDialog/RadixDialog'
export interface VerifyOtpDialogProps extends RadixDialogProps {
  destructive?: boolean
  /** Verify button loading state  */
  isLoading?: boolean
  /** Verification handler  */
  onVerify: (value: string) => void
}
export const VerifyOtpDialog: FC<VerifyOtpDialogProps> = ({
  title,
  smallTitle,
  destructive,
  errorMessage,
  isLoading,
  onClose,
  skipCloseButton,
  onVerify,
}) => {
  const [otp, setOtp] = useState<string>('')
  const [otpFormType, setOtpFormType] = useState<'otp' | 'backup_code'>('otp')
  const submitDisabled = otpFormType === 'otp' && otp.length !== 6
  const onSubmit = () => {
    if (!submitDisabled) {
      onVerify(otp)
    }
  }
  const handleChange: ChangeEventHandler<HTMLInputElement> = e => {
    setOtp(e.target.value)
  }

  return (
    <RadixDialog
      title={title || t`Authentication Required`}
      errorMessage={errorMessage}
      onClose={onClose}
      skipCloseButton={skipCloseButton}
      buttons={[
        {
          action: 'close',
          label: t({ id: 'Cancel' }),
          type: 'outline',
        },
        {
          label: t({ id: 'Verify' }),
          disabled: submitDisabled,
          loading: isLoading,
          type: destructive ? 'destructive' : 'primary',
          action: onSubmit,
        },
      ]}
    >
      <form onSubmit={onSubmit}>
        <Label>
          {smallTitle ||
            (otpFormType === 'backup_code' ? (
              <Trans>Enter one of your unused backup codes</Trans>
            ) : (
              <Trans>Enter the six-digit code from your app</Trans>
            ))}
        </Label>
        {otpFormType === 'otp' && (
          <>
            <Input
              maxLength={6}
              value={otp}
              onChange={handleChange}
              autoFocus
              placeholder="XXX-XXX"
            />
            <Paragraph>
              <Button
                variant={'buttons.link'}
                onClick={() => {
                  setOtpFormType('backup_code')
                  setOtp('')
                }}
              >
                {t({ id: 'Use a backup code' })}
              </Button>
            </Paragraph>
          </>
        )}
        {otpFormType === 'backup_code' && (
          <>
            <Input value={otp} onChange={handleChange} autoFocus />
            <Paragraph>
              <Button
                variant={'buttons.link'}
                onClick={() => {
                  setOtpFormType('otp')
                  setOtp('')
                }}
              >
                {t({ id: 'Verification Code' })}
              </Button>
            </Paragraph>
          </>
        )}
      </form>
    </RadixDialog>
  )
}
